"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResponsivePlacementSizes = void 0;
/**
 * return all the sets of sizes that a placement supports based off the currentWidth provided
 */
function getResponsivePlacementSizes(responsiveSizes, currentWidth) {
    var sizes = Object.keys(responsiveSizes).sort();
    var closestSize;
    // Loop through the array to find the biggest breakpoint
    // Below the provided width
    sizes.forEach(function (i) {
        if (parseInt(i, 10) <= currentWidth) {
            closestSize = i;
        }
    });
    return closestSize ? responsiveSizes[closestSize] : undefined;
}
exports.getResponsivePlacementSizes = getResponsivePlacementSizes;
